import template from './loansHeader.html';
import './loansHeader.scss';

let loansHeaderComponent = {
  restrict: 'E',
  transclude: true,
  bindings: {
    title: '@'
  },
  template
};

export default loansHeaderComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/components/loansHeader/loansHeader.component.js